<template>
    <section class="results-range">
        <h4 class="results-range__label">
            {{ $t('pages.referrals.new.steps.results.range.label') }}
        </h4>

        <div class="results-range__switch">
            <!--
                This is prototype range swith that uses SelectInput. It should use
                custom switcher based on designs once map feature is continued.
            -->
            <select-input
                :value="value"
                :options="options"
                @change="emitEvent({ name: 'change', payload: $event })"
            ></select-input>
        </div>
    </section>
</template>

<script>
    import SelectInput from 'components/form-inputs/SelectInput'

    export default {
        components: {
            SelectInput,
        },

        props: {
            value: { type: Number, required: true },
            options: { type: Array, required: true },
        },
    }
</script>
